import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const de = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join(".") : "");

export const GuestAccessPanel = ({ bookingId }) => {
  const [g, setG] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get(`/bookings/${bookingId}/guest-access`).then((r) => setG(r.data)).catch(() => setG(null)); }, [bookingId]);

  const act = async (path, confirmText) => {
    if (confirmText && !window.confirm(confirmText)) return;
    setBusy(true);
    try { const r = await api.post(`/bookings/${bookingId}/guest-access/${path}`); setG((p) => ({ ...p, ...r.data })); toast.success(path === "revoke" ? "Zugang gesperrt" : "Neuer Zugang erzeugt"); }
    catch (e) { toast.error(e.response?.data?.detail || "Fehler"); }
    finally { setBusy(false); }
  };
  const copy = () => navigator.clipboard?.writeText(g.link).then(() => toast.success("Link kopiert – z. B. in WhatsApp einfügen"));

  if (!g) return null;
  const m = g.meldeschein;
  return (
    <div className="rounded-xl border p-3 space-y-2" data-testid="guest-access-panel">
      <div className="flex items-center justify-between gap-2">
        <div className="font-semibold text-sm">Gästebereich (Website) · {g.booking_number}</div>
        <div className="text-xs text-muted-foreground">gültig bis {de(g.expires_at)}</div>
      </div>
      {g.link ? (
        <code className="block text-xs break-all bg-muted rounded px-2 py-1" data-testid="guest-access-link">{g.link}</code>
      ) : (
        <div className="text-xs text-amber-700" data-testid="guest-access-revoked">{g.cancelled ? "Stornierte Buchung – kein Zugang." : "Zugang gesperrt."}</div>
      )}
      <div className="flex flex-wrap gap-2">
        {g.link && <Button size="sm" type="button" onClick={copy} data-testid="guest-access-copy-btn">Link kopieren</Button>}
        {g.link && <Button size="sm" type="button" variant="outline" disabled={busy} onClick={() => act("revoke", "Zugang sperren? Der bisherige Link funktioniert dann nicht mehr.")} data-testid="guest-access-revoke-btn">Sperren</Button>}
        {!g.cancelled && <Button size="sm" type="button" variant="outline" disabled={busy} onClick={() => act("regenerate", "Neuen Schlüssel erzeugen? Der alte Link wird ungültig.")} data-testid="guest-access-regenerate-btn">Neu erzeugen</Button>}
      </div>
      {m && (
        <div className="text-xs text-muted-foreground border-t pt-2" data-testid="guest-meldeschein">
          Meldeschein: geb. {de(m.birth_date)} · {m.nationalities?.join(", ")} · Mitreisende {m.co_travellers_count}
          {m.co_travellers_nationalities?.length ? ` (${m.co_travellers_nationalities.join(", ")})` : ""}
          {m.id_document_number ? ` · Ausweis ${m.id_document_number}` : ""} · wird gelöscht am {de(m.delete_after)}
        </div>
      )}
    </div>
  );
};
